const shelves = [
    {
        id: 1,
        name: 'Currently Reading',
        value: 'currently-reading'
    },
    {
        id: 2,
        name: 'To Read',
        value: 'to-read'
    },
    {
        id: 3,
        name: 'Read',
        value: 'read'
    },
    {
        id: 4,
        name: 'Did Not Finish',
        value: 'did-not-finish'
    }
];

type CategoryType = 'fictie' | '#top' | 'non-fictie' | 'spannend';

const CATEGORIES = {
    'fictie': {
        id: 'fictie' as CategoryType,
        displayName: 'Fictie'
    },
    '#top': {
        id: '#top' as CategoryType,
        displayName: 'Top 60'
    },
    'non-fictie': {
        id: 'non-fictie' as CategoryType,
        displayName: 'Non Fictie'
    },
    'spannend': {
        id: 'spannend' as CategoryType,
        displayName: 'Spanning'
    }
} as const;

interface book {
    "Book Id": number,
    "Title": string,
    "Author": string,
    "Author l-f": string,
    "Additional Authors"?: string,
    "ISBN"?: string,
    "ISBN13"?: string,
    "My Rating": number,
    "Average Rating": number,
    "Publisher": string,
    "Binding": string,
    "Number of Pages": number,
    "Pages Read": number | null,
    "Year Published": number,
    "Original Publication Year": number,
    "Date Read"?: any,
    "Date Added": Date,
    "Cover URL": string,
    "Bookshelves": string,
    "Genres": Array<number>,
    "Exclusive Shelf": string,
    "My Review": string,
    "Read Count": number,
    "Owned Copies": number,
    "Serie Id": string,
    "Serie": string,
    "Serie Position"?: number,
    "In User Library": boolean
  }

export { shelves, CATEGORIES };
export type { CategoryType, book };
